function MainDashboardCtrl(ReviewService, AppSettings, toaster, $rootScope, CommonService, $stateParams, $state) {
  'ngInject';

  const vm = this;
  vm.reviewStatuses = [];
  vm.loading = false;
  vm.yearArray = [...Array(new Date().getFullYear() - (2018 -1)).keys()].map(function (i) { return i + 2018 ; }).reverse();
  vm.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  // moment is used instead of date provided by js
  // date parses "2019-01-01" to invalid "2018-12-31"
  // moment.utc parses it to "2019-01-01"

  vm.date = !$stateParams.date ? moment() : moment.utc($stateParams.date);
  vm.year = vm.date.year();
  vm.month = vm.date.month() + 1;
  vm.monthName = vm.months[vm.month - 1];
  vm.statusArray = ['Complete', 'Due', 'Waiting', 'Error'];
  vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
  vm.size = !$stateParams.size ? 50 : $stateParams.size;
  vm.orgName = !$stateParams.orgName ? '' : $stateParams.orgName;
  vm.reviewStatus = !$stateParams.reviewStatus ? '' : $stateParams.reviewStatus;
  vm.assistantFlag = false;
  vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
  vm.sortFlag = false;
  vm.tryNowDate = '';

  vm.init = function () {
    $rootScope.organizationNameView = false;
    vm.url = `/organization_review_statuses.json?page=${vm.pageNumber}&size=${vm.size}&date=${vm.year}-${vm.month}-01&by_organization_name=${vm.orgName}&by_review_assistant=${vm.reviewStatus}&sort=${vm.sortBy}`;
    vm.loading = true;
    ReviewService.getReviewStatuses(vm.url, function (response) {
      vm.loading = false;
      if (response.status == 200) {
        vm.mainDashResponse = response.data;
        vm.currentPage = !vm.mainDashResponse.pagination ? 1 : vm.mainDashResponse.pagination.current_page;
        vm.totalPages = !vm.mainDashResponse.pagination ? 1 : vm.mainDashResponse.pagination.total_pages;
        vm.reviewStatuses = response.data.review_statuses;
        if(!parseInt($rootScope.currentOrg)){
          $rootScope.currentOrg = vm.reviewStatuses[0].api_v1_organization.id;
        }else{
          $rootScope.currentOrg = parseInt($rootScope.currentOrg);
        }
      }
    });
  };

  vm.changeYear = function () {
    const month = vm.month > 9 ? vm.month : '0' + vm.month;
    $state.go('user.mainDashboard', { date: `${vm.year}-${month}-01` });
  };

  vm.monthReview = function (selectedMonth) {
    vm.monthName = vm.months[selectedMonth - 1];
    vm.month = selectedMonth;
    vm.changeYear();
  };

  vm.search = function (orgName, reviewStatus) {
    $state.go('user.mainDashboard', { orgName: orgName, reviewStatus: reviewStatus, pageNumber: 1});
  };

  vm.paginate = function (param) {
    vm.url = vm.mainDashResponse.links[param];
    if (vm.url) {
      var arr = vm.url.split('?');
      vm.pageNumber = CommonService.getParameterByName('page', vm.url);
      vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
      $state.go('user.mainDashboard', { pageNumber: vm.pageNumber, size: vm.size });
    }
  };

  vm.rowChange = function (param, pageSize) {
    vm.url = vm.mainDashResponse.links[param];
    var arr = vm.url.split('?');
    vm.pageNumber = 1;
    vm.size = pageSize;
    vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
    $state.go('user.mainDashboard', { pageNumber: vm.pageNumber, size: vm.size });
  };

  vm.sortFlag = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        return false;
      }
    }
    return true;
  };

  vm.sort = function(param) {
    var currentSort = $stateParams.sortBy;
    if(currentSort && currentSort.includes(param))
    {
      if(!currentSort.includes('-'))
      {
        param = '-' + param;
      }
    }
    $state.go('user.mainDashboard', {sortBy: param});
  };

  vm.getReviewAssistant = function (reviewAssistant) {
    if(reviewAssistant == 'complete'){
      return 'completeStatus';
    } else if(reviewAssistant == 'due'){
      return 'dueStatus';
    } else if(reviewAssistant == 'waiting'){
      return 'waitingStatus';
    } else if(reviewAssistant == 'error'){
      return 'errorStatus';
    }
  };

  vm.gotoReview = function (organizationId) {
    $state.go('user.organization.dashboard.review',{orgId: organizationId, date: `${vm.year}-${vm.month}-01`});
  };

  vm.tryNow = function () {
    vm.tryLoading = true;
    ReviewService.tryNowDashboard(vm.tryNowDate, function (response) {
      vm.tryLoading = false;
      if (response.status >= 200 && response.status < 300) {
        toaster.pop('info', response.data.data);
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.onTryNowDateSelect = function(pikaday) {
    vm.tryNowDate = pikaday.toString();
  };

  vm.onPikadayOpen = function (pikaday) {
    vm.tryNowPicker.setMaxDate(new Date());
  };
  
}

export default {
  name: 'MainDashboardCtrl',
  fn: MainDashboardCtrl
}
